import localizationData from "./en.json";
import localized from "model/events/util";

const events = (context) =>
  [
    {
      title: "event.posse.title",
      minDifficulty: 0,
      maxDifficulty: 0.5,
      isCombat: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.posse.spring.day.description",
          },
          night: {
            description: "event.posse.spring.night.description",
          },
        },
        {
          season: "summer",
          day: {
            description: "event.posse.summer.day.description",
          },
          night: {
            description: "event.posse.summer.night.description",
          },
        },
        {
          // "autum" here matched nothing: getEventVariant compares against
          // calendar.season().toLowerCase(), and Calendar.Autum's *value* is 'Autumn' — only
          // the constant's name is misspelled. The posse is the tier that turns up below crime
          // level 2, so for a quarter of the year the filter returned no variant, `[0]` was
          // undefined, and the encounter dismissed the screen instead of appearing.
          season: "autumn",
          day: {
            description: "event.posse.autumn.day.description",
          },
          night: {
            description: "event.posse.autumn.night.description",
          },
        },
        {
          season: "winter",
          day: {
            description: "event.posse.winter.day.description",
          },
          night: {
            description: "event.posse.winter.night.description",
          },
        },
      ],
      buttons: [
        {
          title: "event.posse.button.fight",
          combat: {
            description: "event.posse.button.fight.description",
            victory: "event.posse.button.fight.victory",
            defeat: "event.posse.button.fight.defeat",
            enemies: ["lawman", "deputy"],
          },
        },
        {
          title: "event.posse.button.surrender",
          message: "event.posse.button.surrender.message",
          effect: {
            resources: {
              coins: -Math.floor(
                context.party.resources.attribs.coins.value * 0.5,
              ),
            }, // Lose half coins
            traits: {
              infamy: -Math.max(
                1,
                context.party.progression.getCurrentLevelIndex("crime"),
              ),
              respect: -Math.max(
                1,
                context.party.progression.getCurrentLevelIndex("crime"),
              ),
            }, // Decrease infamy for cooperating with the law
          },
        },
      ],
    },
    {
      title: "event.bountyHunter.title",
      minDifficulty: 0.3,
      maxDifficulty: 0.8,
      isCombat: true,
      description: "event.bountyHunter.description",
      buttons: [
        {
          title: "event.bountyHunter.button.fight.title",
          combat: {
            description: "event.bountyHunter.button.fight.description",
            victory: "event.bountyHunter.button.fight.victory",
            defeat: "event.bountyHunter.button.fight.defeat",
            enemies: ["bountyHunter"],
          },
        },
        {
          title: "event.bountyHunter.button.surrender",
          message: "event.bountyHunter.button.surrender.message",
          effect: {
            resources: {
              coins: -Math.floor(
                context.party.resources.attribs.coins.value * 0.5,
              ),
            }, // Lose half coins
            traits: {
              infamy: -Math.max(
                1,
                context.party.progression.getCurrentLevelIndex("crime"),
              ),
              respect: -Math.max(
                1,
                context.party.progression.getCurrentLevelIndex("crime"),
              ),
            }, // Decrease infamy for cooperating with the law
          },
        },
      ],
    },
    {
      title: "event.marshal.title",
      minDifficulty: 0.7,
      maxDifficulty: 1,
      isCombat: true,
      description: "event.marshal.description",
      buttons: [
        {
          title: "event.marshal.button.fight.title",
          combat: {
            description: "event.marshal.button.fight.description",
            victory: "event.marshal.button.fight.victory",
            defeat: "event.marshal.button.fight.defeat",
            enemies: ["marshal", "deputy"],
          },
        },
        {
          title: "event.marshal.button.surrender",
          message: "event.marshal.button.surrender.message",
          effect: {
            resources: {
              coins: -Math.floor(
                context.party.resources.attribs.coins.value * 0.5,
              ),
            }, // Lose half coins
            traits: {
              infamy: -Math.max(
                1,
                context.party.progression.getCurrentLevelIndex("crime"),
              ),
              respect: -Math.max(
                1,
                context.party.progression.getCurrentLevelIndex("crime"),
              ),
            }, // Decrease infamy for cooperating with the law
          },
        },
      ],
    },
  ].map((event) => localized(event, localizationData));

export default events;
